/**
 * Pick which error object the quest signup UI should surface in its warning dialog.
 *
 * A backend join / eligibility rejection (E_NOT_WHITELISTED, E_NOT_MINIMUM_AVERAGE_VIEWERS,
 * E_NOT_CONNECTED_TO_TWITCH, ...) is stored in redux at `config.quest.errors`. The modern
 * quest page previously passed only `user.myUserQuests.errors` to <QuestSelector>, so those
 * rejections were never displayed — a failed signup looked like nothing happened. Prefer the
 * join error when one is present, otherwise fall back to the existing user-quest error so no
 * current behavior is lost.
 *
 * @param {{message?: string}} joinErrors      config.quest.errors
 * @param {{message?: string}} userQuestErrors user.myUserQuests.errors
 * @returns {object} the error object whose `message` the dialog should show
 */
export const selectQuestSignupError = (joinErrors = {}, userQuestErrors = {}) =>
  (joinErrors && joinErrors.message ? joinErrors : userQuestErrors);

export default selectQuestSignupError;
